module.exports = __webpack_public_path__ + "static/media/52_B.1e856bde.png";